import React from "react";
import { renderBrandText } from "../utils/brandText";
import "./LegalNotice.css";

const LegalNotice = () => {
    return (
        <div className="legal-notice-container" translate="no">
            <h1>Aviso Legal</h1>

            <h3>Datos identificativos del titular</h3>
            <p>
                En cumplimiento de lo establecido en el artículo 10 de la Ley 34/2002,
                de Servicios de la Sociedad de la Información y del Comercio Electrónico (LSSICE),
                se informa a los usuarios de los siguientes datos:
            </p>

            <ul>
                <li><strong>Titular:</strong> Diego Sánchez</li>
                <li><strong>Nombre del proyecto:</strong> {renderBrandText("TheQAHub")}</li>
                <li><strong>Ámbito territorial:</strong> España</li>
                <li>
                    <strong>Correo de contacto:</strong>{" "}
                    <a href="mailto:diego.sanchez@theqahub.com">
                        diego.sanchez@theqahub.com
                    </a>
                </li>
                <li>
                    <strong>Web:</strong>{" "}
                    <a href="https://www.theqahub.es" target="_blank" rel="noreferrer">
                        https://www.theqahub.es
                    </a>
                </li>
            </ul>

            <h3>1. Finalidad del sitio web</h3>
            <p>
                {renderBrandText("TheQAHub es una plataforma orientada a la divulgación, formación y comunidad")}
                en torno al Quality Assurance, testing de software y desarrollo tecnológico.
                El presente Aviso Legal regula el acceso, uso y navegación del sitio web,
                así como las responsabilidades derivadas del uso de sus contenidos.
            </p>

            <p>
                Los contenidos del Sitio Web incluyen, entre otros, artículos técnicos,
                recursos formativos, materiales audiovisuales, código, diseños y cualquier
                otro elemento protegido por la normativa de propiedad intelectual.
            </p>

            <p>
                El acceso y uso del Sitio Web implica la adquisición de la condición de Usuario
                y la aceptación íntegra de las condiciones aquí recogidas.
            </p>

            <h3>2. Condiciones de acceso y uso</h3>
            <p>
                El acceso al Sitio Web es libre y gratuito. Determinados contenidos o servicios
                podrán estar sujetos a registro previo o contratación específica, lo cual se
                indicará expresamente en cada caso.
            </p>

            <p>
                El Usuario se compromete a facilitar información veraz y actualizada, siendo
                responsable de los datos que proporcione a través de los formularios disponibles
                en el Sitio Web.
            </p>

            <p>
                El uso del Sitio Web deberá realizarse conforme a la legislación vigente,
                la buena fe y el orden público. En particular, queda prohibido:
            </p>

            <ul>
                <li>Utilizar los contenidos con fines ilegales o no autorizados.</li>
                <li>Copiar, redistribuir o modificar los contenidos sin permiso expreso.</li>
                <li>Usar el Sitio Web con fines comerciales no autorizados.</li>
                <li>Suplantar identidades o aportar información falsa.</li>
            </ul>

            <h3>3. Seguridad y funcionamiento</h3>
            <p>
                El Usuario se abstendrá de realizar cualquier acción que pueda comprometer
                la seguridad, estabilidad o disponibilidad del Sitio Web.
            </p>

            <p>
                Quedan expresamente prohibidas, entre otras, las siguientes conductas:
            </p>

            <ul>
                <li>Eludir o intentar eludir medidas de seguridad.</li>
                <li>Acceder a áreas restringidas sin autorización.</li>
                <li>Introducir software malicioso, virus o scripts dañinos.</li>
                <li>Realizar acciones que perjudiquen a otros usuarios.</li>
                <li>Enviar comunicaciones masivas no solicitadas (spam).</li>
            </ul>

            <h3>4. Propiedad intelectual</h3>
            <p>
                Todos los derechos de propiedad intelectual e industrial del Sitio Web,
                incluidos su estructura, diseño, contenidos y nombre comercial,
                pertenecen a {renderBrandText("TheQAHub")} o a sus legítimos titulares.
            </p>

            <p>
                El Usuario no adquiere ningún derecho de explotación sobre los contenidos
                más allá del uso estrictamente personal y privado.
            </p>

            <p>
                Queda prohibida cualquier forma de reproducción, distribución o comunicación
                pública sin autorización expresa.
            </p>

            <h3>5. Limitación de responsabilidad</h3>
            <p>
                {renderBrandText("TheQAHub trabaja para ofrecer información actualizada y un funcionamiento")}
                estable del Sitio Web, aunque no garantiza la inexistencia de errores
                técnicos o interrupciones.
            </p>

            <p>
                {renderBrandText("TheQAHub no se hace responsable de los daños que puedan derivarse de:")}
            </p>

            <ul>
                <li>Fallos técnicos o interrupciones del servicio.</li>
                <li>Presencia de virus u otros elementos externos.</li>
                <li>Uso indebido del Sitio Web por parte del Usuario.</li>
                <li>Contenidos o servicios ofrecidos por terceros.</li>
            </ul>

            <h3>6. Enlaces a terceros</h3>
            <p>
                El Sitio Web puede incluir enlaces a páginas externas. {renderBrandText("TheQAHub no controla")}
                ni se responsabiliza del contenido, políticas o prácticas de dichos sitios.
            </p>

            <h3>7. Vigencia y modificaciones</h3>
            <p>
                El presente Aviso Legal podrá ser modificado en cualquier momento.
                La continuidad en el uso del Sitio Web implicará la aceptación de los cambios.
            </p>

            <h3>8. Nulidad parcial</h3>
            <p>
                Si alguna cláusula del presente Aviso Legal fuera declarada inválida,
                el resto de disposiciones permanecerán plenamente vigentes.
            </p>

            <h3>9. Incumplimiento de las condiciones</h3>
            <p>
                El incumplimiento de este Aviso Legal podrá dar lugar a la suspensión
                o cancelación del acceso al Sitio Web, sin perjuicio de las acciones
                legales que correspondan.
            </p>

            <h3>10. Legislación aplicable</h3>
            <p>
                El presente Aviso Legal se rige por la legislación española.
                Cualquier conflicto se resolverá ante los tribunales competentes
                conforme a la normativa vigente.
            </p>

            <p><strong>Última revisión:</strong> marzo de 2026</p>
        </div>
    );
};

export default LegalNotice;
